import { render, staticRenderFns } from "./PeoplePanel.vue?vue&type=template&id=996f70d6"
import script from "./PeoplePanel.vue?vue&type=script&lang=js"
export * from "./PeoplePanel.vue?vue&type=script&lang=js"
import style0 from "./PeoplePanel.vue?vue&type=style&index=0&id=996f70d6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports